import { createAction, createAsyncThunk } from "@reduxjs/toolkit";
import { store } from "../reducers/store";
import { LeoService } from "../../services/leoService";
import { FundFilters, FundItem, IFundCarousel } from "../../models/Fund";

export const setSelectedFund = createAction<number | undefined>('libraryOfFunds/setSelectedFund');
export const toggleShowMore = createAction('libraryOfFunds/toggleShowMore');

export const setPage = createAction('libraryOfFunds/setPage', (page: number) => {
    store.dispatch(setSelectedFund(undefined));
    return { payload: page };
});

export const loadListOfFunds = createAsyncThunk<FundItem[]>(
    'libraryOfFunds/loadListOfFunds',
    async () => {
        const leoService = new LeoService();
        return await leoService.GetFunds();
    });

export const loadFavorites = createAsyncThunk<number[]>(
    'libraryOfFunds/loadFavorites',
    async () => {
        const leoService = new LeoService();
        return await leoService.GetFavorites();
    });
export const addFavorites = createAsyncThunk<number, number>(
    'libraryOfFunds/addFavorites',
    async (fundId:number) => {
        const leoService = new LeoService();
        await leoService.AddFavorites(fundId);
        return fundId;
    });

export const deleteFavorites = createAsyncThunk<number, number>(
    'libraryOfFunds/deleteFavorites',
    async (fundId:number) => {
        const leoService = new LeoService();
        await leoService.DeleteFavorites(fundId);
        return fundId;
    });
    
export const updateFilters = createAction<FundFilters>('libraryOfFunds/updateFilters');

export const loadCarousel = createAsyncThunk<IFundCarousel>(
    'libraryOfFunds/loadCarousel',
    async () => {
        const leoService = new LeoService();
        return await leoService.GetCarousel();
    });